import React from 'react';

import { CompanyDetails } from '@models/next/Company';

export interface MemberDetailsContextValue {
  companyDetails: CompanyDetails;
}

export const MemberDetailsContext = React.createContext<MemberDetailsContextValue>(
  undefined as any,
);
